module.exports = "https://afdep-calmac-mr-glb-uat-brhuhudbgtfee6a6.a02.azurefd.net/assets/scripts/apps/overlays/1.10/img/OfflineIndicator.svg";